import dayjs from "dayjs";
import { store } from "../../redux/store/store"
export const DG_Format_Date = (value, format) => {

    let { dateFormat } = store.getState().defaultSettingReducer

    if (dateFormat) {
        dateFormat = "DD/MM/YYYY"
    }

    if (value)
        return dayjs(value).format(format || dateFormat)
    else
        return ""

}

export const DG_Format_Date_DayOfWeek = (value, format) => {

    if (value) {
        const date = new Date(value)
        const daysOfWeek = ['Chủ nhật', 'Thứ hai', 'Thứ ba', 'Thứ tư', 'Thứ năm', 'Thứ sáu', 'Thứ bảy'];
        const dayIndex = date.getDay();
        return daysOfWeek[dayIndex];
    } else {

        return ""
    }
}

store.subscribe(DG_Format_Date)




